<template>
  <div
    class="search-histories"
    v-if="keyword_suggestions.length > 0"
    @keydown.up.prevent="handleUp"
    @keydown.down.prevent="handleDown"
  >
    <p class="search-suggest__title">検索候補</p>
    <ul class="search-suggest__list">
      <li
        class="search-suggest__item"
        :class="{ focus: focus_suggestion_index === index }"
        v-for="(keyword_suggestion, index) in keyword_suggestions"
        :key="keyword_suggestion"
      >
        <button
          class="search-suggest__item-main"
          type="button"
          :class="`js-focus${index}`"
          @click="goToSearchResults(keyword_suggestion, index)"
        >
          <i
            class="glyphs glyphs-search search-suggest__icon"
            aria-hidden="true"
          ></i>
          {{ keyword_suggestion }}
        </button>
        <button
          class="search-suggest__item-sub"
          type="button"
          @click="setCurrentKeyword(keyword_suggestion)"
        >
          <i class="glyphs glyphs-arrow_upper_left" aria-hidden="true"></i>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  SET_CURRENT_KEYWORD,
  FOCUS_SEARCH_INPUT
} from '../../store/mutation-types';
import { captureEvent } from '../../../common/utils';
import utils, { UNFOCUSED } from '../../utils';

export default {
  computed: {
    ...mapGetters(['keyword_suggestions', 'focus_suggestion_index'])
  },

  watch: {
    focus_suggestion_index: function(newIndex, _oldIndex) {
      // フォーカスが外れた場合はSearchForm.vueで処理
      if (newIndex !== UNFOCUSED) {
        const searchButtonEl = this.$el.querySelector(
          `.js-focus${this.focus_suggestion_index}`
        );
        searchButtonEl && searchButtonEl.focus();
      }
    }
  },

  methods: {
    ...mapActions([
      'decrementFocusCandidateIndex',
      'incrementFocusCandidateIndex'
    ]),

    goToSearchResults(keyword, index) {
      captureEvent({
        category: 'サイト内検索',
        action: 'SearchPartsClick',
        label: 'suggest-search',
        value: index + 1
      });
      this.$store.commit(SET_CURRENT_KEYWORD, keyword);
      utils.goToSearchURL('/search/topics', { q: keyword });
    },

    setCurrentKeyword(keyword) {
      this.$store.dispatch('updateKeywordAndSuggestions', `${keyword} `);
      this.$store.commit(FOCUS_SEARCH_INPUT);
    },

    handleUp() {
      this.decrementFocusCandidateIndex();
    },

    handleDown() {
      this.incrementFocusCandidateIndex();
    }
  }
};
</script>
